// extracted by mini-css-extract-plugin
export default {"text":"DownloadButton_text__LqASY","icon":"DownloadButton_icon__mNQmr","container":"DownloadButton_container__a+QWz"};